<app-response-text class="page-message" [lambdaMessage]="lambdaMessage" [lambdaError]="lambdaError"></app-response-text>

<ng-template #header>
    <div class="filter-bar">
        <mat-icon matTooltip="Show advanced filters" *ngIf="!additionalFilters" (click)="additionalFilters = !additionalFilters">chevron_right</mat-icon>
        
        <span *ngIf="additionalFilters" class="filter">
            Queues: <app-combo-box allowDropdownStretch="true" [(value)]="queueFilter" (valueSelect)="setQueueFilter($event)" [options]="queues"></app-combo-box>
        </span>

        <span *ngIf="additionalFilters" class="filter">
            Contact Flows: <app-combo-box allowDropdownStretch="true" [(value)]="contactFlowFilter" (valueSelect)="setContactFlowFilter($event)" [options]="callFlows"></app-combo-box>
        </span>

        <span *ngIf="additionalFilters" class="filter">
            Lambdas: <app-combo-box allowDropdownStretch="true" [(value)]="lambdaFilter" (valueSelect)="setLambdaFilter($event)" [options]="lambdas"></app-combo-box>
        </span>

        <div *ngIf="additionalFilters" class="btn" (click)="applyAdvancedFilter()">Apply</div>

        <div *ngIf="additionalFilters" class="btn white" (click)="removeAdvancedFilter()">Clear</div>

        <mat-icon *ngIf="additionalFilters" (click)="additionalFilters = !additionalFilters; removeAdvancedFilter()">chevron_left</mat-icon>
    </div>
</ng-template>

<div class="page-data-grid">
    <app-mat-data-grid 
        [(dataSource)]="filterdData"
        [displayedColumns]="['name', 'description', 'queues', 'contactFlows', 'lambdas']"
        [displayDefinition]="{
            'queues': queueDisplay,
            'contactFlows': flowDisplay,
            'lambdas': lambdaDisplay
        }"
        [columnNames]="['Name', 'Description', 'Queues', 'Contact Flows', 'Lambdas']"
        [headerTwo]="header"
        [pageSizeOptions] = "[10, 25, 50, 100]"
        [buttonConfig]="{
            edit: {show: false},
            delete: {show: false}
        }"
        [showButtons] = "false"
        [objectBluePrint]="{}"
        (buttonClick)="handleButtonEvent($event)"
        >
    </app-mat-data-grid>
</div>


<ng-template #flowDisplay let-item>
    <app-select-and-display [items]="item"></app-select-and-display>
</ng-template>

<ng-template #queueDisplay let-item>
    <app-select-and-display [items]="item"></app-select-and-display>
</ng-template>

<ng-template #lambdaDisplay let-item>
    <app-select-and-display [items]="item" [displayNameFunction]="getLambdaName"></app-select-and-display>
</ng-template>